<template>
    <div class="cfy-dialog cont-sty">
        <el-row :gutter="40">
            <el-col :span="11">
                <div class="treebox">
                    <div class="search-sty">
                        <el-input placeholder="请输入关键词检索" size="mini" prefix-icon="el-icon-search" v-model="keyValue" @input="queryStudyfyTree"></el-input>
                    </div>
                    <div class="lefttree">
                        <el-tree
                            :data="treeData"
                            show-checkbox
                            node-key="label"
                            ref="tree"
                            :default-expanded-keys="defaultChoose"
                            check-strictly
                            highlight-current
                            check-on-click-node
                            :load="loadNode"
                            lazy
                            :props="defaultProps" @check="oncheck"
                            @check-change="checkChangeTrueFale">
                        </el-tree>
                    </div>
                </div>
            </el-col>
            <el-col :span="11">
                <div class="treebox">
                    <p class="tit">已选择
                        <button class="clearbtn" @click="clearDialog" v-if="right.length > 0"><i class="el-icon-delete"></i>清空</button>
                    </p>
                    <ul v-if="right" class="tree right-tree">
                        <li v-for="(item,index) in right" :key="index" >
                            <span>{{item.label.label}}</span>
                            <i class="el-icon-circle-close" @click="delSel(item.label.label)"></i>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <div class="btn_box">
            <button class="btn_canle" @click="closeDialog">取消</button><button class="btn_sure" @click="confirmDialog">确定</button>
        </div>
    </div>
</template>

<script>
import {Form,Button,Input,Row,Col,Notification,Tree,Loading} from 'element-ui';
import message from '../common/utils/message'
import { searchlist } from '@/api/img.js'
export default {
    props:['msg'],//子接收父级传来的
    data() {
        return {
            keyValue:'',
            treeData:null,
            choosedData:[],
            txt:null,
            classify:[],
            defaultProps: {
                children: 'children',
                label: 'label',
                isLeaf: 'leaf'
            },
            right:[],
            defaultChoose:['01哲学'],
            msgCode:''
        }
    },
    watch: {
        // keyValue(){
        //     let vm = this;
        //     vm.queryStudyfyTree()
        // }
    },
    mounted() {
        let vm = this;
        if(vm.msg){
            let preArr = vm.msg.split('|'),
                arr1 = preArr[0].split(','),
                arr2 = preArr[1].split(',');
            vm.defaultChoose=arr2;
            arr2.forEach((ele,i) => {
                vm.classify.push({'label':ele});
                vm.right.push({
                    'label':{
                        'label':ele,
                        'subjectCode':arr1[i]
                    }
                });
            });
        }
        vm.queryStudyfyTree('1');

    },
    components: {
        Form,Button,'el-input':Input,'el-row':Row,'el-col':Col,Notification,
        'el-tree':Tree,Loading
    },
    methods: {
        queryStudyfyTree(num) {
            let vm = this,params={};
                // url = '/purch/v2/public/pt/subject/action/search/list';
            num = (!vm.keyValue || num== '1') ? '1': null;
            params = {
                classifyLevel:num,
                name:vm.keyValue,
                gid:'',
                // keyValue:vm.keyValue
            };
            searchlist(params).then(res => {
            // vm.$http.get(url,{params:params}).then(res => {
                let data = res.data;
                if(data && data.length > 0){
                        if(!num){
                            data.forEach(et => {  
                                et.leaf = true;
                            });
                        }
                        vm.treeData = data;
                        vm.setCode(vm.treeData);
                    
                }else{
                    vm.treeData = null
                }
            }).catch(res => {
                Notification.error({title:'提示',message:res.msg || '操作失败请稍后再试！',duration:2000});
            })
        },
        // 异步树叶子节点懒加载逻辑
        loadNode(node, resolve) {
            // 一级节点处理
            if(node.level === 0) {
                return resolve([]);
            } else {
                this.getIndex(node, resolve);
            }
        },
        // 异步加载叶子节点数据函数
        getIndex(node, resolve) {
            let vm = this;
            if(!node.data.leaf) {
                node.leaf = true;
                let params = {
                    gid: node.data.gid
                }

                searchlist(params).then(res => {
                // vm.$http.get('/purch/v2/public/pb/subject/action/search/list',{params:params}).then(res => {
                    let parentData = res.data[0],
                        data = parentData.children || [];
                    // 处理节点是否是叶子节点
                    if(data && data.length > 0){
                        data.forEach(et => {
                            if(et.leaf !== false) {
                                et.leaf = true;
                            } else {
                                et.leaf = false;
                            }
                        });
                        vm.setCode(data);
                    }
                    resolve(data);
                    parentData.label = `${parentData.subjectCode}${parentData.subjectName}`;
                    let parentNode = vm.$refs.tree.getNode(parentData);
                    if(parentNode.data.disabled) {
                        parentNode.childNodes.forEach(ele => {
                        vm.$set(ele.data, 'disabled', true);
                        });
                    }
                    vm.$nextTick(() => {
                        let classifyLabel = [];
                        vm.classify.forEach(ele => {
                            classifyLabel.push(
                                ele.label
                            )
                        });
                        vm.$refs.tree.setCheckedKeys(classifyLabel);
                    })
                });
            } else return resolve([]);
        },
        setCode(data){
            var vm = this;
            data.forEach( ele => {
                let label = `${ele.subjectCode}${ele.subjectName}`;
                vm.$set(ele,'label',label);
            });
        },
        checkChangeTrueFale(a, b, c) {
            if(b) {
                let ch = this.$refs.tree.getNode(a);
                ch.childNodes.forEach(ele => {
                    ele.childNodes.forEach(ele => {
                        ele.childNodes.forEach(ele => {
                            ele.childNodes.forEach(ele => {
                                ele.childNodes.forEach(ele => {
                                    this.$set(ele.data, 'disabled', true);
                                })
                                this.$set(ele.data, 'disabled', true);
                            })
                            this.$set(ele.data, 'disabled', true);
                        })
                        this.$set(ele.data, 'disabled', true);
                    })
                    this.$set(ele.data, 'disabled', true);
                });
            } else {
                let ch = this.$refs.tree.getNode(a);
                ch.childNodes.forEach(ele => {
                    ele.childNodes.forEach(ele => {
                        ele.childNodes.forEach(ele => {
                            ele.childNodes.forEach(ele => {
                                ele.childNodes.forEach(ele => {
                                    this.$set(ele.data, 'disabled', true);
                                })
                                this.$set(ele.data, 'disabled', false);
                            })
                            this.$set(ele.data, 'disabled', false);
                        })
                        this.$set(ele.data, 'disabled', false);
                    })
                    this.$set(ele.data, 'disabled', false);
                });
            }
        },
        delSel(dad){
            let vm = this,rightList = [],index=null;
            vm.right.forEach(ele => {
                rightList.push(ele.label.label);
            });
            index = rightList.indexOf(dad);
            if(index != -1) {
                    rightList.splice(index, 1);
                    vm.classify.splice(index, 1);
                    vm.$refs.tree.setCheckedKeys([]);
                    if(rightList.length > 0) vm.$refs.tree.setCheckedKeys(rightList);
                }
                vm.right.splice(index, 1);
        },
        oncheck(a, b){
            let vm = this;
            let thischeckStr = a.label //当前选中的属性转换
            let thischeckArr = [{
                "label": {
                    "label": a.label,
                    "subjectCode": a.subjectCode
                }
            }];
            let rightArr = [];
            vm.right.forEach(ele => {
                rightArr.push(ele.label.label);
            });
            if(rightArr.indexOf(thischeckStr) != -1) {
                let thisRightArr = vm.right;
                let thisright = rightArr;
                let index = thisright.indexOf(thischeckStr);
                thisRightArr.splice(index, 1);
                vm.right = thisRightArr; //右边
                let checkArr = [];
                vm.right.forEach(ele => {
                    checkArr.push({
                        "label": ele.label.label,
                        "subjectCode": ele.label.subjectCode
                    })
                });
                vm.classify = checkArr; //左边
            }else{
                let thisrightyuy = [];
                thisrightyuy = vm.right;
                let newRight = thisrightyuy.concat(thischeckArr);
                vm.right = newRight; //右边
                let checkArr2 = [];
                vm.right.forEach(ele => {
                    checkArr2.push({
                        "label": ele.label.label,
                        "subjectCode": ele.label.subjectCode
                    })
                });
                vm.classify = checkArr2; //左边
            }
        },
        closeDialog(e, bool=false, txt=null) {
            let vm = this;
            vm.$emit('close');
        },
        confirmDialog() {
            let vm = this,len = vm.choosedData.length,dataArr=[],codesArr = [],dataStr=[],gids=[],labelArr=[],namedata=[],txt = vm.$refs.tree.getCheckedNodes();
            if(vm.right.length == 0){
                dataStr = '';
                vm.msgCode = '';
            }else{
                if(vm.right.length != txt.length) {
                    vm.right.forEach(ele => {
                        dataArr.push(ele.label.label);
                        codesArr.push(ele.label.subjectCode);
                    });
                    // vm.msgCode = codesArr.join(',');
                    // vm.msg = dataArr;
                    dataStr = `${String(codesArr)}|${String(dataArr)}`;
                    // vm.filterText = '';
                }else {
                    txt.forEach(ele => {
                        labelArr.push(ele.label);
                        codesArr.push(`${ele.subjectCode}`);
                    });
                    dataStr = `${String(codesArr)}|${String(labelArr)}`;
                    // vm.msgCode = codesArr.join(',');
            }
            }
            vm.$emit('ok',dataStr);
        },
        clearDialog() {
            let vm = this;
            vm.classify = [];
            vm.right = [];
            vm.$refs.tree.setCheckedKeys([]);
        }
    }
    
};
</script>


<style lang='scss' >
.search-wrap{
        padding: 15px;
        // width: 1150px;
        width: calc(100% - 30px);
        // margin-left:calc(50% - 600px);
        position: relative;
        margin-top:16px;
        background-color:#fff;
        position: relative;
        overflow: hidden;
        // &.dropdown{
        //     height: 10px;
        // }
        .drop_btn{
            position: absolute;
            display: block;
            line-height: 50px;
            padding: 0px 40px;
            cursor: pointer;
            bottom: 0px;
            right: 0px;
            color: #999;
        }
        .no-margin{
            margin:0 !important;
            // width:72px;
        }
        .el-input{
            /* width: 192px; */
            width: 100%;
        }
        .el-input__inner{
            padding:0px 8px;
            /* width: 192px; */
        }   
        .s-input{   
            float: left;
            width:75px;
            .el-form-item__content{
                .midbox{
                    width: 52px;
                }
            }      
            .el-input__inner{
                padding:0px 8px;
                width: 52px;
            }
        }
        .date-input{
            float: left;
            width:130px;
            .el-input__inner{
                padding:0px 8px;
                width: 128px;
            }
        }
        .el-input--prefix .el-input__inner{
            padding-left:25px;
        }
        .line{
            text-align: center;
        }
        .s-input{
            .el-input{
                width:70%;
            }
            i{
                font-style: normal;
            }
        }
        .el-form-item__label{
            padding-right:5px;
            font-size: 12px;
        }
        .search-btn{
            text-align: center;
            padding-top:15px;
        }       
        
        //表单清除
        .labelwrap{
            position: relative;
            .circleclose{display: none}
            .el-form-item__content:hover .circleclose{
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }
    }
    
    /* 分类弹框样式    //学科、大众 */
    .cont-sty{
     
        .el-col .treebox{
            width: 209px;
            height: 323px;
            padding: 15px 0 0 15px;
            padding-right:0px;
            margin:28px 0 0 38px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #c9d7e8;
            .search-sty{
                .el-input__inner{
                    width: 200px;
                    height: 32px;
                    padding-left: 28px;
                    background-color: #fff;
                    border-radius: 16px;
                    height: 28px;
                    line-height: 28px;
                    border: solid 1px #b6d2e6;
                }
                .el-icon-search{
                    line-height: 32px;
                }
            }
            .lefttree{
                height: 291px;
                overflow: auto;
                list-style: none;
                .check-box{
                    cursor: pointer;
                    margin-top:10px;
                }
            }
            .tit{
                font-weight: bold;
                font-size: 13px;
            }
            .right-tree{
                width: 209px;
                height: 301px;
                overflow: auto;
                list-style: none;
                padding: 0px;
                >li{
                    cursor:pointer;
                    margin-top:10px;
                    span{
                        display: inline-block;
                        width: 170px;
                        font-size: 12px;
                    }
                    i{
                        font-size: 17px;
                        color:#bbc8d4;
                    }
                    &:hover i{
                        color:#1c7bd3;
                    }
                }
                >li:hover{
                    color: #1c7bd3;
                }
            }
            .noData{
                text-align: center;
                font-size: 12px;
                img{
                    height: 90px;
                    width: 70px;
                    margin: 30px auto 15px;
                    display: block;
                }
                .p{
                    margin: 4px;
                }
            }
            
        }    
    }
    .clearbtn {
        float: right;
        margin-right: 18px;
        width: 47px;
        height: 22px;
        line-height: 22px;
        background-color: #ffeaea;
        border-radius: 2px;
        border: 1px solid #f2c3c3;
        color: #ce4747;
    }
    .btnbase{
        border: 0px;
        // border-radius: 50px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        // padding:0 24px;
        display:inline-block;
        height: 33px;
        line-height:33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }
    .btn_box{
        //按钮样式
        text-align: center;
        margin-top:15px;
        .btn_sure{
            @extend .btnbase ;
            color: #fff;
            background-color:#2c88f4;
        }
        .btn_canle{
            @extend .btnbase ;
            color:  #2c88f4;
            background-color:  #deefff;
        }
        .btn_green{
            @extend .btnbase ;
            color: #fff;
            background-color:#67c23a;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/studyClassPop.vue